import React from 'react';
import { WaterReleaseSignatureCanvas } from './WaterReleaseSignatureCanvas';
import { WaterReleaseSignatureImage } from './WaterReleaseSignatureImage';

export const WaterReleaseSignature = ({ edit, ...props }) =>
  edit ? <WaterReleaseSignatureCanvas {...props} /> : <WaterReleaseSignatureImage {...props} />;
